import { render, staticRenderFns } from "./edge.vue?vue&type=template&id=7ccb09e4&scoped=true"
import script from "./edge.vue?vue&type=script&lang=js"
export * from "./edge.vue?vue&type=script&lang=js"
import style0 from "./edge.vue?vue&type=style&index=0&id=7ccb09e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccb09e4",
  null
  
)

export default component.exports